import React from 'react';

export function appBar(theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          // Uses CSS custom properties defined in cssBaseline :root.
          // viewport-fit=cover in index.html enables env(safe-area-inset-*).
          paddingTop: 'var(--safe-area-top)',
          paddingLeft: 'var(--safe-area-left)',
          paddingRight: 'var(--safe-area-right)',
        },
      },
    },
  };
}
